import {ApiService} from "./ApiService";

export const NewsApi = {
    list(pageNumber = 0, pageSize = 20, emo, province, keyword) {
        let params = {
            page: pageNumber,
            size: pageSize,
        }
        if (emo) {
            params["emo"] = emo
        }
        if (province) {
            params["province"] = province
        }
        if (keyword) {
            params["keyword"] = keyword
        }
        return ApiService.get("/api/v1/news/list", params)
    },

    keywordCloud(days = 7) {
        return ApiService.get("/api/v1/news/keyword/cloud", {days: days})
    },

    getNews(sid) {
        return ApiService.get("/api/v1/news", {sid: sid})
    },

    getKeywords(sid) {
        return ApiService.get("/api/v1/news/keywords", {sid: sid})
    }
}